import { useMsal } from '@azure/msal-react';
import AddIcon from '@mui/icons-material/Add';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { Button, Stack, Tooltip } from '@mui/material';
import { useAtom } from 'jotai';

import { isIPadPro } from '../../../helpers/iPadProUtil/iPadProUtil';
import { formModeAtom, selectedEventAtom, showEventPaneAtom, showFilterAtom } from '../../../state/atoms/atoms';
import ExportDocButton from '../../ExportDocButton/ExportDocButton';

export const ActionBar = () => {
  const [, setshowEventPane] = useAtom(showEventPaneAtom);
  const [, setShowFilters] = useAtom(showFilterAtom);
  const [, setFormMode] = useAtom(formModeAtom);
  const [, setSelectedEvent] = useAtom(selectedEventAtom);
  const { instance } = useMsal();
  const userRoles = instance?.getAllAccounts()?.[0]?.idTokenClaims?.roles;
  const bypassRoleForE2E = import.meta.env.VITE_E2E === 'true';

  const onNewEventClick: () => void = () => {
    setSelectedEvent(null);
    setFormMode('new');
    setshowEventPane(true);
  };

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{ justifyContent: { xs: 'space-between', sm: 'space-between', md: 'flex-end' } }}
    >
      <Tooltip title="Open filters pane" sx={{ display: { xs: 'flex', sm: 'flex', md: 'none' } }}>
        <Button
          size="small"
          variant="text"
          color="inherit"
          onClick={() => setShowFilters(true)}
          startIcon={<FilterAltIcon fontSize="small" />}
        >
          Filters
        </Button>
      </Tooltip>

      {(bypassRoleForE2E || userRoles?.includes('GEC.Admin') || userRoles?.includes('GEC.EventOrganizer')) && (
        <Tooltip title="Create a new event">
          <Button
            size="small"
            variant="text"
            color="inherit"
            onClick={onNewEventClick}
            startIcon={<AddIcon fontSize="small" />}
          >
            New event
          </Button>
        </Tooltip>
      )}
      {!isIPadPro && <ExportDocButton />}
    </Stack>
  );
};
